import i18n from "@/language/i18n";
import REPORT_WIDGETS from "@/configuration/widgets/REPORT_WIDGETS";

const PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    NOTICE_MODULE_WINDOW_ID: 'notices',
    MESSAGE_MODULE_WINDOW_ID: 'messages',
    NOTIFICATION_GROUPS_MODULE_WINDOW_ID: 'notificationgroups',
    TASK_MODULE_WINDOW_ID: 'tasks',
    TEXTBLOCK_MODULE: 'textblocks',
});

export { PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER };

export default {
    PROCESS_SUPPORT_GROUP_WRAPPER: {
        type: 'group',
        id: 'process_support',
        label: i18n.t('Common.processSupport'),
        children: [],
        sidebarIcon: '$wNavProcessSupport'
    },
    CHILDREN: {
        NOTICE_MODULE: {
            type: 'module',
            id: 'notices',
            windowIdentifierType: PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER.NOTICE_MODULE_WINDOW_ID,
            label: i18n.t('Common.notes'),
            routerLink: '/notices',
        },
        MESSAGE_MODULE: {
            type: 'module',
            id: 'messages',
            windowIdentifierType: PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER.MESSAGE_MODULE_WINDOW_ID,
            label: i18n.t('Common.messages'),
            routerLink: '/messages',
        },
        TASK_MODULE: {
            type: 'module',
            id: 'tasks',
            windowIdentifierType: PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER.TASK_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.processSupport.tasks.label'),
            routerLink: '/tasks',
            widgets: REPORT_WIDGETS.TASK_REPORT_WIDGETS
        },
        NOTIFICATION_GROUPS_MODULE: {
            type: 'module',
            id: 'notificationGroups',
            windowIdentifierType:
                PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER.NOTIFICATION_GROUPS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.processSupport.notificationGroups.label'),
            navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
            routerLink: '/notificationgroups',
        },
        TEXTBLOCKS_MODULE: {
            type: 'module',
            id: 'textblocks',
            windowIdentifierType:
                PROCESS_SUPPORT_MODULE_WINDOW_IDENTIFIER.TEXTBLOCK_MODULE,
            label: i18n.t(
                'ModuleRegistry.groups.processSupport.textblocks.label'
            ),
            navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
            routerLink: '/textblocks',
            globalSearch: {
                index: 'textblocks',
                presentation: i18n.t(
                'ModuleRegistry.groups.processSupport.textblocks.label'
                ),
                component: 'TextblockItem',
            },
        },
    }
}
